import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: false}
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('../views/Menu.vue'),
    meta: { requiresAuth: true}
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/Account.vue'),
    meta: { requiresAuth: true}
  },
  {
    path: '/preferences',
    name: 'preferences',
    component: () => import('../views/Preferences.vue'),
    meta: { requiresAuth: true}
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: false}
  },
  {
    path: '/recipes',
    name: 'recipes',
    component: () => import('../views/Recipes.vue'),
    meta: { requiresAuth: true}
  },
  {
    path: '/ingredients',
    name: 'ingredients',
    component: () => import('../views/Ingredients.vue'),
    meta: { requiresAuth: true}
  },
  {
    path: '/howitworks',
    name: 'howitworks',
    component: () => import('../views/HowItWorks.vue'),
    meta: { requiresAuth: false}
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/SignUp.vue'),
    meta: { requiresAuth: false}
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// //for restricting access if not authenticated
// router.beforeResolve((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(() => {
//       next();
//     }).catch(() => {
//       next({
//         path: '/auth'
//       });
//     });
//   }
//   next()
// })

//for restricting access if not authenticated
router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(() => {
        console.log(store.getters['data/account']);
        next();
    }).catch(() => {
      next({
        path: '/auth'
      });
    });
  }
  next()
})


export default router
